export default __webpack_public_path__ + "2009ea7663beb0eb3bce4db05e6b9742.svg";